module.exports = {
  GOOGLE_SIGNIN_FROM: 'googleSigninFrom',
  GOOGLE_SIGNIN_SOURCE: 'googleSigninSource',
  IS_WRAPUP_HIDDEN: 'isWrapupHidden',
  GOOGLE_SIGNIN_REDIRECT: 'googleSigninRedirect',
  GOOGLE_SIGNIN_SAVE_WORDCLOUD: 'googleSigninSaveWordcloud',
  GOOGLE_SIGNIN_SAVE_SPINNER_WHEEL: 'googleSigninSaveSpinnerWheel',
  CANVAS_RIGHT_CLICK: 'canvasRightClick',
  HAS_USED_GIPHY: 'hasUsedGiphy',
  AHA_GUEST_USER: 'aha-guest-user',
  ASK_AI_BUTTON_CLICKED: 'ask-ai-button-clicked',
}
